import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Button, InputField } from 'src/components';
import { setFromErrors } from 'src/helpers';
import { useGetFcpsCourseListsForLogbookEntryMutation, useLazyGetFormByLogbookTypeAndSubjectQuery } from 'src/rtk/features/setup/logBookEntrySetupDetails/logBookEntrySetupDetailsApi';
import { useCreateLogbookEntrySetupMasterMutation } from 'src/rtk/features/setup/logBookEntrySetupMaster/logBookEntrySetupMasterApi';
import { useGetSubjectInfosQuery } from 'src/rtk/features/setup/subjectInfo/subjectInfoApi';
import * as Yup from 'yup';
import { TargetSetupForAcademicActivities } from './TargetSetupForAcademicActivities';

const initialValues: LogbookEntrySetupMaster = {
  id: '',
  setup_logbook_master_id: '',
  logbook_entry_setup_master_id: '',
  particulars: '',
  details: '',
  note: '',
  help: '',
  is_show_ind: 1,
  sl_no: 0,
  particulary_type: 1,
  course_type: '',
  target_minimum: 0,
  target_maximum: 0,
  status: true,
  creator_organization_id: '',
  updater_organization_id: '',
  created_by: '',
  updated_by: '',
  deleted_by: '',
  created_at: '',
  updated_at: '',
  deleted_at: '',
};

interface QueryParams {
  id?: number;
  course_type?: string;
  subject_id?: string;
  main_training?: string;
}

export const AddAcademicSetupMaster = () => {
  const [createLogbookEntrySetupMaster, { isSuccess, isError, error }] = useCreateLogbookEntrySetupMasterMutation();
  const [getForms, { data: formSetups, isSuccess: isFormSetupsSuccess, isLoading: isFormSetupsLoading, isFetching: isFormSetupsFetching }] =
    useLazyGetFormByLogbookTypeAndSubjectQuery();

  const [showStatus, setShowStatus] = useState<boolean>(true);
  const [subject, setSubject] = useState<SubjectInfo>(
    {} as SubjectInfo
  );
  const [queryParams, setQueryParams] = useState<QueryParams>(
    {} as QueryParams,
  );
  const [selectedSubject, setSelectedSubject] = useState<any>('');

  const [mainTrainings, setMainTrainings] = useState<FcpsCourseList[]>([]);
  const [forms, setForms] = useState<LogbookEntrySetupMaster[]>([]);
  const [selectedForm, setSelectedForm] = useState<LogbookEntrySetupMaster | null>(null);
  const [selectedSystemTypeObject, setSelectedSystemTypeObject] = useState<LogbookEntrySetupMaster | null>(null);
  const [selectedTopicTypeObject, setSelectedTopicTypeObject] = useState<LogbookEntrySetupMaster | null>(null);
  const [coreAdvanceOptions, setCoreAdvanceOptions] = useState<SelectOption[]>([]);

  // New state for entry type and system type
  const [entryType, setEntryType] = useState<string>(''); // 'system' or 'topic'
  const [systemTypes, setSystemTypes] = useState<any[]>([]);
  const [selectedSystemType, setSelectedSystemType] = useState<string>('');
  const [selectedTopicType, setSelectedTopicType] = useState<string>('');

  const [mainTraining, setMainTraining] = useState<FcpsCourseList>(
    {} as FcpsCourseList,
  );

  const { data: getSubjectInfolist } = useGetSubjectInfosQuery();
  const subjects = getSubjectInfolist?.data;

  let formOptions: SelectOption[] =
    forms?.map((e: LogbookEntrySetupMaster) => {
      return {
        label: e.particulars!,
        value: e.id!,
      };
    }) ?? [];


  // system type options from selected form's entry_master_data
  const systemTypeOptions: SelectOption[] =
    systemTypes?.map((caseType: any) => ({
      label: caseType.particulars, // Adjust based on your data structure
      value: caseType.id,
    })) || [];

  const topicTypeOptions: SelectOption[] =
    selectedSystemTypeObject?.entry_setup_master?.map((topicType: any) => ({
      label: topicType.particulars,
      value: topicType.id,
    })) || [];

  const [createFcpsCourse, { data: fcpsCourseListData, isSuccess: isFcpsCourseListSuccess, isError: isFcpsCourseListError, error: fcpsCourseListError }] =
    useGetFcpsCourseListsForLogbookEntryMutation();

  const history = useHistory();

  const err: CustomError = error as CustomError;
  const { handleSubmit, handleChange, setFieldValue, getFieldProps, values, touched, errors, resetForm, setErrors } =
    useFormik({
      initialValues,
      validationSchema: Yup.object({
        setup_logbook_master_id: Yup.string().required('Please select the logbook master'),
      }),

      onSubmit: (values) => {
        if (showStatus) {
          values.is_show_ind = 1;
        } else {
          values.is_show_ind = 0;
        }

        createLogbookEntrySetupMaster({
          ...values,
        });
        console.log(values);
      },
    });

  useEffect(() => {
    if (isSuccess) {
      // resetForm();
      toast.success('Logbook entry setup master created successfully');
      // history.push('/setup/logbook-entry-setup-master');
    }
    if (isError) {
      toast.error(err?.message || 'Something went wrong');
      setFromErrors(err.data, setErrors);
    }
  }, [isSuccess, isError]);

  let subjectOptions: SelectOption[] =
    subjects?.map((subject) => ({
      value: subject.id!,
      label: subject.subject_name,
    })) || [];

  let mainTrainingOptions: SelectOption[] =
    mainTrainings?.map((mainTraining) => ({
      value: mainTraining.id!,
      label: mainTraining.name!,
    })) || [];

  useEffect(() => {
    if (subject?.id) {
      createFcpsCourse(subject?.id!);
    }
  }, [subject]);

  useEffect(() => {
    if (isFcpsCourseListSuccess && fcpsCourseListData?.success) {
      const mainTrainings: FcpsCourseList[] = fcpsCourseListData.data;
      setMainTrainings(mainTrainings);
    } else {
      setMainTrainings([]);
    }
  }, [isFcpsCourseListSuccess, fcpsCourseListData?.success]);

  const handleMainTrainingOption = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    const mainTraining = mainTrainings?.find(
      (mainTraining) => mainTraining.id === value,
    );
    setMainTraining(mainTraining!);
    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.main_training = mainTraining?.id;
    newQueryParams.course_type = '';
    setQueryParams(newQueryParams);
    setForms([]);

    if (value === '') {
      setCoreAdvanceOptions([]);
    } else {
      setCoreAdvanceOptions([
        { label: 'Core', value: 'core' },
        { label: 'Specialty', value: 'adv' },
      ]);
    }
  };

  const handleCoreAdvance = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    values.course_type = value;
    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.course_type = value;
    setQueryParams(newQueryParams);

    if (value === '') {
      setForms([]);
    } else {
      setForms(formSetups?.data!);
    }
  };

  const handleShowStatus = (e: any) => {
    setShowStatus(e.target.checked);
  };

  const handleEntryTypeChange = (e: any) => {
    const { value } = e.target;
    setEntryType(value);

    // Reset system type when entry type changes
    setSelectedSystemType('');
    setSystemTypes([]);

    // Reset particulars field
    setFieldValue('particulars', '');
  };

  useEffect(() => {
    const subject = subjects?.find((subject) => subject.id === selectedSubject?.value);
    setSubject(subject!);

    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.subject_id = subject?.id;
    newQueryParams.main_training = '';
    newQueryParams.course_type = '';
    setQueryParams(newQueryParams);
    setCoreAdvanceOptions([]);
    setForms([]);

    setMainTraining({ id: '' } as FcpsCourseList);

    if (selectedSubject?.value === '') {
      setMainTrainings([]);
    }
  }, [selectedSubject]);

  useEffect(() => {
    if (
      queryParams.subject_id &&
      queryParams.main_training &&
      queryParams.course_type
    ) {
      const updatedParams = { ...queryParams, id: 2 };
      getForms(updatedParams);
    }
  }, [queryParams]);

  useEffect(() => {
    if (formSetups && isFormSetupsSuccess) {
      setForms(formSetups?.data);
    }
  }, [formSetups, isFormSetupsSuccess]);

  const handleFormSelect = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    const form = forms.find((form) => form.id === value);
    setSelectedForm(form || null);

    setSelectedSystemType('');

    console.log(form);
  };

  useEffect(() => {
    if (selectedForm && entryType === 'system') {
      setFieldValue('setup_logbook_master_id', selectedForm?.setup_logbook_master_id);
      setFieldValue('logbook_entry_setup_master_id', selectedForm?.id);
    }
    else if (selectedForm && (entryType === 'topic' || entryType === 'skillName')) {
      if (selectedForm && selectedForm.entry_setup_master) {
        setSystemTypes(selectedForm.entry_setup_master);
      } else {
        setSystemTypes([]);
      }
    }

  }, [selectedForm, entryType])

  const handleSystemTypeSelect = (e: any) => {
    const { value } = e.target;
    const systemType = systemTypes.find((systemType) => systemType.id === value);
    setSelectedSystemTypeObject(systemType || null);

    setSelectedSystemType(value);
  };

  useEffect(() => {
    if (selectedSystemTypeObject && entryType === 'topic') {
      setFieldValue('setup_logbook_master_id', selectedSystemTypeObject?.setup_logbook_master_id);
      setFieldValue('logbook_entry_setup_master_id', selectedSystemTypeObject?.id);
      // console.log(selectedSystemTypeObject)
    }
  }, [selectedSystemTypeObject, entryType]);

  const handleTopicTypeSelect = (e: any) => {
    const { value } = e.target;
    const topicType = selectedSystemTypeObject?.entry_setup_master?.find((topicType) => topicType.id === value);

    setSelectedTopicTypeObject(topicType || null);

    setSelectedTopicType(value);
    console.log(topicType);
  }

  useEffect(() => {
    if (selectedTopicTypeObject && entryType === 'skillName') {
      setFieldValue('setup_logbook_master_id', selectedTopicTypeObject?.setup_logbook_master_id);
      setFieldValue('logbook_entry_setup_master_id', selectedTopicTypeObject?.id);
      // console.log(selectedTopicTypeObject)
    }
  }, [selectedTopicTypeObject, entryType]);
  return (
    <>
      <div className="row align-items-center justify-content-center">
        <Form
          className="custom-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-3">
                <Label className="form-label">Subject</Label>
                <Select
                  isClearable={true}
                  isSearchable={true}
                  value={selectedSubject}
                  onChange={setSelectedSubject}
                  options={subjectOptions}
                  placeholder="Select Subject"
                  name="subject"
                  id="subject"
                />
              </FormGroup>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-3">
                <Label className="form-label">Main Training</Label>
                <InputField
                  type="select"
                  name="mainTraining"
                  placeholder=""
                  value={mainTraining?.id}
                  options={mainTrainingOptions}
                  onChange={(e) => {
                    handleMainTrainingOption(e);
                  }}
                />
              </FormGroup>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-3">
                <Label className="form-label">Core/Speciality</Label>
                <InputField
                  type="select"
                  name="course_type"
                  placeholder=""
                  options={coreAdvanceOptions}
                  onChange={(e) => {
                    handleCoreAdvance(e);
                  }}
                />
              </FormGroup>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-3">
                <Label className="form-label required-field">Form</Label>
                <InputField
                  type="select"
                  name="setup_logbook_master_id"
                  placeholder=""
                  value={selectedForm?.id}
                  options={formOptions}
                  onChange={(e) => {
                    handleFormSelect(e);
                  }}
                  invalid={{ errors, touched }}
                />
              </FormGroup>
            </div>

            {/* New Entry Type Selection */}
            <div className='col-lg-8 col-md-8 col-sm-12 mt-4'>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="entry_type"
                  value="system"
                  onChange={(e) => {
                    setEntryType(e.target.value);
                  }}
                  checked={entryType === 'system'}
                  id="system-type"
                />
                <label
                  className="form-check-label"
                  htmlFor="system-type"
                >
                  Add System Type
                </label>
              </div>

              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="entry_type"
                  value="topic"
                  onChange={(e) => {
                    setEntryType(e.target.value);
                  }}
                  checked={entryType === 'topic'}
                  id="topic-type"
                />
                <label
                  className="form-check-label"
                  htmlFor="topic-type"
                >
                  Add Topic Type
                </label>
              </div>

              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="entry_type"
                  value="skillName"
                  onChange={(e) => {
                    setEntryType(e.target.value);
                  }}
                  checked={entryType === 'skillName'}
                  id="skillName-type"
                />
                <label
                  className="form-check-label"
                  htmlFor="skillName-type"
                >
                  Add Skill Type
                </label>
              </div>
            </div>

            {/* system Type Dropdown - Only show when topic type is selected */}
            {(entryType === 'topic' || entryType === 'skillName') && (
              <div className="col-lg-4 col-md-6 col-sm-12">
                <FormGroup className="mb-3">
                  <Label className="form-label">System Type</Label>
                  <InputField
                    type="select"
                    name="case_type"
                    placeholder="Select system type"
                    value={selectedSystemType}
                    options={systemTypeOptions}
                    onChange={handleSystemTypeSelect}
                  />
                </FormGroup>
              </div>
            )}

            {entryType === 'skillName' && (
              <div className="col-lg-4 col-md-6 col-sm-12">
                <FormGroup className="mb-3">
                  <Label className="form-label">Topic Type</Label>
                  <InputField
                    type="select"
                    name="topic_type"
                    placeholder="Select topic type"
                    value={selectedTopicType}
                    options={topicTypeOptions}
                    onChange={handleTopicTypeSelect}
                  />
                </FormGroup>
              </div>
            )}

            {/* Particulars Field - Show when system type is selected OR when topic type is selected */}
            {(entryType === 'system' || entryType === 'topic' || entryType === 'skillName') && (
              <div className="col-lg-4 col-md-6 col-sm-12">
                <FormGroup className="mb-3">
                  <Label for="particulars">{entryType === 'skillName' ? 'Skill Type' : entryType === 'system' ? 'System Type' : entryType === 'topic' ? 'Topic Type' : ''}</Label>
                  <InputField
                    type="textarea"
                    placeholder="Write here..."
                    invalid={{ errors, touched }}
                    {...getFieldProps('particulars')}
                  />
                </FormGroup>
              </div>
            )}
            <div className="col-sm-12">
              <FormGroup check className="mb-3 mt-4">
                <Label check>
                  <Input type="checkbox" checked={values.status} {...getFieldProps('status')} />{' '}
                  Status
                </Label>
              </FormGroup>
            </div>
          </div>
          <Button type="submit" text="Submit" className='px-5' />
        </Form>
      </div>
      <div className="mt-5">
        <Label className='block-heading w-100'>
          Target Setup For Academic Activities
        </Label>
        <TargetSetupForAcademicActivities />
      </div>
    </>
  );
};